import {createMuiTheme} from '@material-ui/core';


const theme=createMuiTheme({
    palette:{
        primary:{
            main:'#234a83'
        },
        secondary:{
            main:'#800000'
        }
    }
})
export default theme;